import React from 'react';
import { Search, Users, LineChart, Star, Zap, Globe, Layers, ShieldCheck } from 'lucide-react';
import Container from '../layout/Container';
import SectionTitle from '../ui/SectionTitle';
import FeatureCard from '../ui/FeatureCard';

const FeaturesSection: React.FC = () => {
  const features = [
    {
      title: 'Powerful Search',
      description: 'Offer your clients lightning-fast property search with customizable filters and interactive maps.',
      icon: <Search size={24} />,
    },
    {
      title: 'Lead Generation',
      description: 'Capture and nurture leads with smart forms, saved searches, and automated follow-ups.',
      icon: <Users size={24} />,
    },
    {
      title: 'Market Reports',
      description: 'Provide valuable insights with customizable market reports and trend analysis.',
      icon: <LineChart size={24} />,
    },
    {
      title: 'Premium Design',
      description: 'Impress clients with beautiful, responsive designs that showcase your properties in style.',
      icon: <Star size={24} />,
    },
    {
      title: 'AI-Powered Tools',
      description: 'Leverage artificial intelligence for property descriptions, social media captions, and personalized recommendations.',
      icon: <Zap size={24} />,
    },
    {
      title: 'SEO Optimization',
      description: 'Rank higher in search results with built-in SEO tools and automatically optimized listing pages.',
      icon: <Globe size={24} />,
    },
    {
      title: 'Multiple Tiers',
      description: 'Choose from Core, Engage, and Elite plans to find the perfect solution for your business needs.',
      icon: <Layers size={24} />,
    },
    {
      title: 'MLS Compliance',
      description: 'Rest easy knowing your website is fully compliant with FMLS and RESO guidelines.',
      icon: <ShieldCheck size={24} />,
    },
  ];

  return (
    <section className="py-20 bg-neutral-50">
      <Container>
        <SectionTitle
          title="Features Designed for Real Estate Success"
          subtitle="Powerful tools to grow your business and delight your clients"
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              delay={index}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default FeaturesSection;